import attendanceRuleConfig from '@/pages/systemConfig/attendanceRuleConfig.vue';
import classAndGradeConfig from '@/pages/systemConfig/classAndGradeConfig.vue';
import studentInfoConfig from '@/pages/systemConfig/studentInfoConfig.vue';
import buildingConfig from '@/pages/systemConfig/buildingConfig.vue';
import roleAuthorizationConfig from '@/pages/systemConfig/roleAuthorizationConfig.vue';
import channelDevConfig from '@/pages/systemConfig/channelDevConfig.vue';

export default {
    menuName: '系统配置',
    path: '/xtpz',
	children: [{
		path: 'ldss',
		menuName: '楼栋宿舍配置',
		component: buildingConfig,
    },{
            path: 'tdsb',
            menuName: '通道设备配置',
            component: channelDevConfig,
        },{
		path: 'bjxx',
		menuName: '班级信息配置',
		component: classAndGradeConfig,
	},{
		path: 'xsxx',
		menuName: '学生信息配置',
		component: studentInfoConfig,
	},{
		path: 'jsqx',
		menuName: '角色权限配置',
		component: roleAuthorizationConfig,
    }, {
		path: 'kqgz',
		menuName: '考勤规则配置',
		component: attendanceRuleConfig,
	}],
	component: (resolve) => require(['@/pages/systemConfig/index.vue'], resolve)
}


// WEBPACK FOOTER //
// ./src/routes/modules/systemConfig.js